<template>
  <div class="root">
    <div class="button-row">
      <DToolbar @tab-changed="handleTabChange" v-model="tab" title="Dashboard Editor" :tabs="[
        { name: 'tabAll', label: 'All', icon: 'apps' },
        { name: 'tabLayers', label: 'Layers', icon: 'layers' },
        { name: 'tabBubbles', label: 'Datas', icon: 'bubble_chart' }]" />

      <DButton @click="goHome" icon="home" iconColor="black" ripple tooltip=" List of Dashboards" />

    </div>

    <DCard bordered class="editor-block card">
      <div class="button-row" style="justify-content: space-between;">
        <DInput borderless v-model="dashboardState.dashboard.name" label="Name" />
        <DInput readonly borderless v-model="dashboardState.dashboard.id" label="ID" />
        <DInput readonly borderless v-model="dashboardState.dashboard.groupId" label="Group ID" />
        <DInput readonly borderless v-model="dashboardState.dashboard.institutionId" label="Institution ID" />
        <DCheckbox left-label v-model="dashboardState.dashboard.active" label="Active" />
      </div>
    </DCard>
    <div class="content-block">
      <div v-if="tab === 'tabAll' || tab === 'tabLayers'">
        <DCard bordered class="editor-block" v-for="(layer, index) in dashboardState.dashboard.layers" :key="index">
          <DCardSection>
            <h3>Layer</h3>
            <div class="layer-element" style="display: flex; justify-content: flex-start ">
              <img class="image" v-if="layer.image" :src="layer.image.data" :alt="layer.image.name" :height="200"
                style="border: 1px solid black; margin-left: 16px;" />
              <div class="row" style="margin-left: 16px;">
                <DInput readonly borderless v-model="layer.image.name" label="Image name" />
                <DInput borderless v-model="layer.level" label="Level" type="number" />
              </div>
            </div>
          </DCardSection>
          <DExpand :item-padding="'8px 0px'" icon="view_module" label="Elements" v-if="layer.elements.length > 0"
            style="padding-left: 32px;">
            <DCardSection>
              <DCardSection>
                <DCard bordered class="editor-block" v-for="(element, index) in layer.elements" :key="index">
                  <div :style="layer.elements.length < 2 ? 'display: none;' : 'display: flex;'">
                    <div :style="isFirstElement(layer, element) ? 'display: none;' : ''">
                      <DIcon iconName="keyboard_arrow_up" tooltipText="Move up element"
                        @icon-click="moveElement(layer, element, true)" />
                    </div>
                    <div :style="isLastElement(layer, element) ? 'display: none;' : ''">
                      <DIcon tooltipText="Move down element" iconName="keyboard_arrow_down"
                        @icon-click="moveElement(layer, element, false)" />
                    </div>
                  </div>

                  <div class="layer-element">
                    <div class="row" style="display: flex;">
                      <!-- First column -->
                      <div style="flex: 1;">
                        <div>
                          <div class="button-row">
                            <DInput type="number" borderless v-model="element.size" :min=1 label="Size" />
                            <DInput type="range" :min="-100" :max="100" :step=1 label-always borderless
                              v-model="element.speed" label="Speed" />
                            <DInput type="number" borderless v-model="element.speed" :min="-100" :max="100"
                              id="speedInput" />
                          </div>
                          <div class="button-row">
                            <DInput type="number" borderless v-model="element.xPosition" label="X Position" />
                            <DInput type="number" borderless v-model="element.yPosition" label="Y Position" />
                          </div>
                          <div class="button-row">
                            <DInput type="text" v-model="element.path" label="Path" hint="1,5,-10"
                              @blur="updatePath(layer, element)" />
                            <DButton @click="updatePath(layer, element)" icon="edit" iconColor="white" color="blue"
                              tooltip=" Update path" />
                          </div>
                        </div>
                      </div>

                      <!-- Second column -->
                      <div style="flex: 1;margin-left: 32px;">
                        <DImg class="image" v-if="element.image" :src="element.image.data" alt="element.image.name"
                          :fit="'contain'"
                          :style="{ width: '100%', maxHeight: '100px', maxWidth: '400px', transform: element.speed < 0 ? 'scaleX(-1)' : 'scaleX(1)', height: 'auto', marginBottom: '16px' }" />
                        <DInput readonly borderless v-model="element.image.name" label="Name" />
                      </div>
                    </div>
                  </div>
                  <div class="button-row" style="margin-top: 16px;">
                    <DButton class="btn-blue-margin" color="primary" icon="delete" ripple
                      @click="deleteElement(layer, element)" tooltip="Delete element" />
                    <DButton class="btn-blue-margin" color="primary" icon="content_copy" ripple
                      @click="duplicateElement(layer, element)" tooltip="Duplicate element" />
                    <DButton class="btn-blue-margin" color="primary" icon="edit" ripple
                      @click="editElement(layer, element)" tooltip="Edit element" />
                    <div :style="isFirstLayer(layer) ? 'display:none;' : ''">
                      <DButton class="btn-blue-margin" color="primary" @click="moveElementToLayer(layer, element, true)"
                        icon="move_up" ripple tooltip="  Move element to higher
                          layer" />
                    </div>
                    <div :style="isLastLayer(layer) ? 'display:none;' : ''">
                      <DButton class="btn-blue-margin" color="primary" @click="moveElementToLayer(layer, element, false)"
                        icon="move_down" ripple tooltip=" Move element to lower
                          layer" />
                    </div>
                  </div>
                </DCard>
              </DCardSection>

            </DCardSection>
          </DExpand>
          <DCardSection>
            <DButton class="btn-blue-margin" @click="deleteLayer(layer.id, layer)" color="primary" icon="delete" ripple
              style="margin-left: 16px;" tooltip="Delete layer" />
            <DButton class="btn-blue-margin" @click="showElementForm(layer, null)" color="primary" icon="control_point"
              tooltip="Add element" riple />
          </DCardSection>
        </DCard>
      </div>
      <div v-if="tab === 'tabAll' || tab === 'tabBubbles'">
        <DCard bordered class="editor-block" v-for="(data, index) in dashboardState.dashboard.data" :key="index">
          <h4>{{ data.dataTypeIdentifier }}{{ data.identifier }}</h4>
          <DCardSection class="layer-element">
            <div class="layer-element" style="display: flex; justify-content: flex-start ">
              <div style="display: flex; flex-direction: column">
                <img class="image" v-if="data.background" :src="data.background.data" :alt="data.background.name"
                  style="border: 1px solid black;width:100%;max-height: 100px;max-width: 400px;height: auto;" />
                <DButton @click="editDataImg(data, false)" color="primary" label="Edit" />
              </div>
              <div class="column" style="margin-left: 32px;">
                <DInput readonly borderless v-model="data.background.name" label="Image name" />
                <DInput v-model="data.textMain" label="Main text" type="text" />
                <DInput v-model="data.textDetail" label="Detail text" type="text" />
              </div>
              <div style="display: flex; flex-direction: column;margin-left: 16px;">
                <img class="image" v-if="data.icon" :src="data.icon.data" :alt="data.icon.name"
                style="width:100%;max-height: 100px;max-width: 300px;height: auto;" />
                <DButton @click="editDataImg(data, true)" color="primary" label="Edit" />
              </div>
              <div class="column" style="margin-left: 16px;">
                <DInput readonly borderless v-model="data.icon.name" label="Icon name" />
                <DInput v-model="data.textIcon" label="Icon text" type="text" />
              </div>
            </div>
          </DCardSection>

          <DCardSection>
            <div class="button-row">
              <DInput v-model="data.textColorMain" label="Main text color" type="text" :rules="['anyColor']" />
              <DColorPicker :height="50" cover v-model="data.textColorMain" transition-show="scale"
                transition-hide="scale" />

              <DInput v-model="data.textColorDetail" label="Detail text color" type="text" :rules="['anyColor']" />
              <DColorPicker :height="50" cover v-model="data.textColorDetail" transition-show="scale"
                transition-hide="scale" />

              <DInput v-model="data.textColorIcon" label="Icon text color" type="text" :rules="['anyColor']" />
              <DColorPicker :height="50" cover v-model="data.textColorIcon" transition-show="scale"
                transition-hide="scale" />
            </div>
          </DCardSection>
          <DButton class="btn-blue-margin" @click="deleteBubble(data)" color="primary" icon="delete"
            tooltip="Delete bubble" />
        </DCard>
      </div>
    </div>

  </div>
  <footer class="footer">
    <DButton @click="saveContent" label="Save" :disabled="!isDirty" :color="isDirty ? 'positive' : 'gray'" icon="save">
      <span class="loader" :style="isSaving ? '' : 'display: none;'"></span>
    </DButton>
    <DButton class="btn-blue-margin" @click="showLayerForm" color="primary" label="Add Layer" icon="layers" />
    <DButton class="btn-blue-margin" @click="showBubbleForm" color="primary" label="Add Data" icon="bubble_chart" />
  </footer>
  <DNotify ref="notification" />
  <ProgressDialog :loading="isSaving" loadingText="Saving changes.." />
  <DeleteLayerFormDlg :is-visible="deleteLayerFormVisible" @update:isVisible="showDialog = $event"
    @confirm="confirmDeleteLayer" @cancel="cancelDeleteLayer" title="Are you sure?"
    message="You will remove all elements of this layer. Are you sure to delete?" />
  <LayerFormDialog :onlyImg="onlyImg" :is-visible="showLayerFormVisible" @update:isVisible="showDialog = $event"
    @confirm="confirmLayer" @cancel="cancelLayer" @show-notification="showSuccess" />
  <DataTypesFormDialog ref="dataTypesFormDialog" :is-visible="showDataTypesFormVisible"
    @update:isVisible="showDialog = $event" @confirm="confirmDataTypes" @cancel="cancelDataTypes"
    @show-notification="showSuccess" />
  <ElementFromDialog :is-visible="showElementFormVisible" @update:isVisible="showDialog = $event"
    :initialData="objectForFill" @confirm="confirmElement" @cancel="cancelElement" @show-notification="showSuccess" />
</template>


<script>
import { saveDashboardEditorChanges, dashboardStateDeleteBubble } from "../state/dashboard-state"
import LayerFormDialog from "@components/LayerFormDialog.vue"
import ElementFromDialog from "@components/ElementFormDialog.vue"
import DataTypesFormDialog from "@components/DataTypesFormDialog.vue"
import DeleteLayerFormDlg from "@components/DeleteLayerFormDlg.vue"
import ProgressDialog from '@components/ui/ProgressDialog.vue'
import DButton from '@components/ui/DButton.vue'
import DExpand from '@components/ui/DExpand.vue'
import DIcon from '@components/ui/DIcon.vue'
import DToolbar from '@components/ui/DToolbar.vue'
import DCard from '@components/ui/DCard.vue'
import DInput from '@components/ui/DInput.vue'
import DNotify from '@components/ui/DNotify.vue'
import DCheckbox from '@components/ui/DCheckbox.vue'
import DCardSection from '@components/ui/DCardSection.vue'
import DColorPicker from '@components/ui/DColorPicker.vue'
import DImg from '@components/ui/DImg.vue'


export default {
  name: 'DashboardEditor',
  inject: ['dashboardState'],
  components: {
    ProgressDialog: ProgressDialog,
    DButton,
    DExpand,
    DIcon,
    DToolbar,
    DCard,
    DInput,
    DNotify,
    DCheckbox,
    DCardSection,
    DColorPicker,
    DImg,
    DeleteLayerFormDlg,
    LayerFormDialog: LayerFormDialog,
    DataTypesFormDialog: DataTypesFormDialog,
    ElementFromDialog: ElementFromDialog
  },
  computed: {
    /**
 * Checks if the current state of the dashboard has been modified compared to the original state.
 *
 * @returns {boolean} Returns true if the current state of the dashboard is different from the original state, otherwise returns false.
 */
    isDirty() {
      if (!this.originalDashboardState) {
        return false
      }
      return JSON.stringify(this.dashboardState) !== JSON.stringify(this.originalDashboardState)
    }
  },
  methods: {
    /**
     * Navigates the user to the admin page.
     *
     * This method uses Vue Router to navigate to the '/admin' route when called.
     */
    goHome() {
      this.$router.push('/admin')
    },

    /**
 * Checks and adjusts the speed value to be within the range -100 to 100.
 *
 * @param {number} speed - The speed value to check.
 */
    checkSpeed(speed) {
      if (speed < -100) {
        speed = -100
      } else if (speed > 100) {
        speed = 100
      }
    },
    /**
 * Updates the path of a given element in a given layer.
 * If the path is not an array, it converts it to an array.
 * If the path is an array, it converts it to a string and then back to an array.
 *
 * @param {Object} layerObj - The layer object that contains the element.
 * @param {Object} elementObj - The element object whose path is to be updated.
 */
    updatePath(layerObj, elementObj) {
      const layer = this.dashboardState.dashboard.layers.find(layer => layer == layerObj)
      if (layer) {
        const element = layer.elements.find(element => element == elementObj)
        if (element) {
          try {
            if (!Array.isArray(element.path)) {
              if (element.path) {
                element.path = element.path.split(",").map(Number)
              } else {
                element.path = []
              }
            } else {
              if (element.path.length > 0) {
                const stringArray = element.path.join(',')
                element.path = stringArray.split(",").map(Number)
              }
            }
          } catch (error) {
            console.error('elementpath', error)
          }
        }
      }
    },
    /**
 * Asynchronously shows a form for selecting data types and creates new bubbles based on the selected data types.
 *
 * This method opens a dialog with a form for selecting data types. When the user confirms their selection,
 * it creates a new bubble for each selected data type and adds it to the dashboard. The properties of the new bubbles
 * are based on the default properties of the selected data types.
 *
 * @async
 */
    async showBubbleForm() {
      this.showDataTypesFormVisible = true
    },
    cancelDataTypes() {
      this.showDataTypesFormVisible = false
    },
    confirmDataTypes(payload) {
      payload.selectedValues.forEach(typeId => {
        const defaultBubble = this.dashboardState.dataTypeList.find(type => type.id == typeId)
        this.newBubble = {
          dataTypeId: defaultBubble.id,
          icon: {
            name: defaultBubble.defaultIcon.name,
            data: defaultBubble.defaultIcon.data
          },
          background: {
            name: defaultBubble.defaultBackground.name,
            data: defaultBubble.defaultBackground.data
          },
          textIcon: defaultBubble.defaultTextIcon,
          textMain: defaultBubble.defaultTextMain,
          textDetail: defaultBubble.defaultTextDetail,
          textColorIcon: defaultBubble.defaultTextColorIcon,
          textColorMain: defaultBubble.defaultTextColorMain,
          textColorDetail: defaultBubble.defaultTextColorDetail,
          identifier: defaultBubble.identifier
        }
        this.onAddBubble()
      })
      this.showDataTypesFormVisible = false
    },
    /**
 * Opens a specific dialog based on the provided key and index.
 *
 * This method generates a unique dialog key by concatenating the provided key and index.
 * It then sets the value of the dialog key in the `openDialogs` object to `true`, which opens the dialog.
 *
 * @param {string} key - The base key for the dialog.
 * @param {number} index - The index used to make the dialog key unique.
 */
    openDialog(key, index) {
      const dialogKey = key + index
      this.openDialogs[dialogKey] = true
    },
    /**
 * Handles the change event of an image input element.
 *
 * This method gets the first file from the 'imageInput' element and reads it as a Data URL using the FileReader API.
 * When the file is successfully read, it sets the 'src' attribute of the 'imagePreview' element to the Data URL,
 * and makes the 'imagePreview' element visible by setting its 'display' style to 'block'.
 */
    handleImageChange() {
      const imageInput = document.getElementById('imageInput')
      const imageFile = imageInput.files[0]

      if (imageFile) {
        const reader = new FileReader()
        reader.onload = (event) => {
          const imageData = event.target.result
          const previewImage = document.getElementById('imagePreview')
          previewImage.src = imageData;
          previewImage.style.display = 'block'
        }
        reader.readAsDataURL(imageFile)
      }
    },
    /**
 * Opens the layer form to edit an image.
 *
 * @param {Object} dataObj - The data object that contains the image to edit.
 * @param {boolean} isIcon - A flag indicating whether the image is an icon.
 */
    editDataImg(dataObj, isIcon) {
      this.showLayerFormVisible = true
      this.onlyImg = true
      this.bubbleObj = dataObj
      this.isBubbleIcon = isIcon
    },
    /**
 * Asynchronously shows a form for creating a new layer.
 *
 * This method opens a dialog with a form for creating a new layer. When the user confirms their input,
 * it creates a new layer with the provided image, level, and name, and adds it to the dashboard.
 *
 */
    showLayerForm() {
      this.showLayerFormVisible = true
      this.onlyImg = false
    },

    /**
 * Confirms the layer with the given payload and adds it to the layers.
 *
 * @param {Object} payload - The payload for the new layer.
 * @param {string} payload.name - The name of the image for the new layer.
 * @param {string} payload.imagePreview - The data of the image for the new layer.
 * @param {number} payload.level - The level of the new layer.
 */
    confirmLayer(payload) {
      if (this.onlyImg) {
        this.bubbleObj[this.isBubbleIcon ? 'icon' : 'background'] = {
          name: payload.name,
          data: payload.imagePreview
        }
      } else {
        this.newLayer = {
          layerId: '',
          image: {
            name: payload.name,
            data: payload.imagePreview
          },
          level: payload.level,
          elements: []
        }
        this.onAddLayer()
      }
      this.showLayerFormVisible = false
    },
    /**
 * Cancels the layer creation process and hides the layer form.
 */
    cancelLayer() {
      this.showLayerFormVisible = false
    },

    /**
 * Shows the form for adding or editing an element.
 *
 * @function
 * @name showElementForm
 * @param {Object} layerObj - The layer object where the element will be added or edited.
 * @param {Object} objectForFill - The data to prefill the form with. If this is for a new element, it could be null or contain default values.
 * @returns {Promise<void>} A promise that resolves when the operation completes.
 */
    async showElementForm(layerObj, objectForFill) {
      this.showElementFormVisible = true
      this.objectForFill = objectForFill
      this.layerObj = layerObj
    },
    /**
 * Confirms the selection of an element and prepares it for addition.
 *
 * @function
 * @name confirmElement
 * @param {Object} payload - The data of the element to confirm.
 * @param {string} payload.imagePreview - The preview image of the element.
 * @param {number} payload.speed - The speed of the element.
 * @param {string} payload.name - The name of the element.
 * @param {number} payload.size - The size of the element.
 * @param {number} payload.xposition - The x position of the element.
 * @param {number} payload.yposition - The y position of the element.
 * @param {string} payload.path - The path of the element, represented as a string of comma-separated numbers.
 * @returns {void} Executes the function without returning a value.
 */
    confirmElement(payload) {
      this.showElementFormVisible = false
      this.newElement = {
        isEdit: this.objectForFill ? true : false,
        image: {
          name: payload.name,
          data: payload.imagePreview
        },
        speed: payload.speed,
        xPosition: payload.xposition,
        yPosition: payload.yposition,
        size: payload.size,
        path: typeof payload.path === 'string' ? payload.path.split(',').map(Number) : []
      }
      this.onAddElement(this.layerObj)

    },
    /**
 * Cancels the process of adding a new element by hiding the element form.
 *
 * @function
 * @name cancelElement
 * @returns {void} Executes the function without returning a value.
 */
    cancelElement() {
      this.showElementFormVisible = false
    },
    /**
 * Shows a notification with the specified type and message.
 *
 * This method uses the 'showNotification' method of the 'notification' ref to show a notification.
 * The type and message of the notification are specified by the parameters.
 *
 * @param {string} type - The type of the notification. This affects the appearance of the notification.
 * @param {string} message - The message to be displayed in the notification.
 */
    showSuccess(type, message) {
      this.$refs.notification.showNotification(type, message)
    },
    /**
 * Asynchronously saves the changes made in the dashboard editor.
 *
 * This method sets 'isSaving' to true, then calls the 'saveDashboardEditorChanges' function with 'this' as the argument.
 * If the status returned by 'saveDashboardEditorChanges' is 200, it fetches the dashboard data and shows a success notification.
 * Otherwise, it shows an error notification. Finally, it sets 'isSaving' back to false.
 *
 * @async
 * @throws Will throw an error if the 'saveDashboardEditorChanges' function fails.
 */
    async saveContent() {
      this.isSaving = true
      const status = await saveDashboardEditorChanges(this)
      if (status == 200) {
        this.fetchDashboardData()
        this.showSuccess('positive', 'Saving changes was successful!')
      }
      else {
        this.showSuccess('negative', 'Saving changes was unsuccessful!')
      }
      this.isSaving = false
    },
    /**
     * Deletes a bubble from the dashboard data.
     *
     * @param {Object} dataObj - The data object to delete. This is used to identify the bubble to delete.
     */
    deleteBubble(dataObj) {
      dashboardStateDeleteBubble(dataObj)
      this.$refs.dataTypesFormDialog.showBubbleForm()
    },
    /**
 * Deletes a given element from a given layer.
 *
 * @param {Object} layerObj - The layer object that contains the element.
 * @param {Object} elementObj - The element object to delete.
 */
    deleteElement(layerObj, elementObj) {
      const layer = this.dashboardState.dashboard.layers.find(layer => layer === layerObj)
      if (layer) {
        layer.elements = layer.elements.filter(element => element !== elementObj)
      }
    },
    /**
   * Prepares to delete a layer from the dashboard.
   *
   * @param {string} layerId - The id of the layer to delete.
   * @param {Object} object - The layer object to delete.
   */
    deleteLayer(layerId, object) {
      this.deleteLayerFormVisible = true
      this.layerIdToDelete = layerId
      this.layerObjectToDelete = object
    },
    /**
     * Confirms the deletion of a layer from the dashboard.
     * If `layerIdToDelete` is not set, it uses `layerObjectToDelete` for the deletion.
     * After deletion, it hides the delete layer form.
     */
    confirmDeleteLayer() {
      if (!this.layerIdToDelete) {
        this.dashboardState.dashboard.layers = this.dashboardState.dashboard.layers.filter(layer => layer !== this.layerObjectToDelete)
      } else {
        this.dashboardState.dashboard.layers = this.dashboardState.dashboard.layers.filter(layer => layer.id !== this.layerIdToDelete)
      }
      this.deleteLayerFormVisible = false
    },
    /**
     * Hides the delete layer form.
     */
    cancelDeleteLayer() {
      this.deleteLayerFormVisible = false

    },
    /**
 * Adds a new bubble to the dashboard data.
 *
 * This method creates a new bubble with the properties specified in 'this.newBubble', and pushes it to the 'dashboardState.dashboard.data' array.
 * The properties of the new bubble include the data type ID, icon, background, text icon, main text, detail text, icon text color, main text color, and detail text color.
 * After adding the new bubble, it logs the updated 'dashboardState.dashboard.data' array to the console.
 */
    onAddBubble() {
      this.dashboardState.dashboard.data.push({
        //  id: this.setDataUniqId(),
        dataTypeId: this.newBubble.dataTypeId,
        icon: {
          name: this.newBubble.icon.name,
          data: this.newBubble.icon.data
        },
        background: {
          name: this.newBubble.background.name,
          data: this.newBubble.background.data
        },
        textIcon: this.newBubble.textIcon,
        textMain: this.newBubble.textMain,
        textDetail: this.newBubble.textDetail,
        textColorIcon: this.newBubble.textColorIcon,
        textColorMain: this.newBubble.textColorMain,
        textColorDetail: this.newBubble.textColorDetail,
        identifier: this.newBubble.identifier
      })
    },
    /**
     * Adds a new layer to the dashboard.
     *
     * This method creates a new layer with the level and image specified in 'this.newLayer', and pushes it to the 'dashboardState.dashboard.layers' array.
     * The new layer includes a level, an image with a name and data, and an empty array of elements.
     * After adding the new layer, it logs the new layer to the console.
     */
    onAddLayer() {
      this.dashboardState.dashboard.layers.push({
        //  id: this.setLayerUniqId(),
        level: this.newLayer.level,
        image: {
          name: this.newLayer.image.name,
          data: this.newLayer.image.data
        },
        elements: []
      })
    },
    /**
 * Duplicates a given element in a given layer.
 * The new element has the same properties as the original element.
 *
 * @param {Object} layerObj - The layer object that contains the element.
 * @param {Object} elementObj - The element object to duplicate.
 */
    duplicateElement(layerObj, elementObj) {
      const layer = this.dashboardState.dashboard.layers.find(layer => layer === layerObj)
      const element = layer.elements.find(element => element === elementObj)
      layer.elements.push({
        // id: this.setElementUniqId(layer),
        image: element.image,
        speed: element.speed,
        xPosition: element.xPosition,
        yPosition: element.yPosition,
        size: element.size,
        path: element.path
      })
    },
    /**
     * Edits a given element in a given layer.
     * It finds the layer and element in the dashboard state and then shows the element form.
     *
     * @param {Object} layerObj - The layer object that contains the element.
     * @param {Object} elementObj - The element object to edit.
     */
    editElement(layerObj, elementObj) {
      const layer = this.dashboardState.dashboard.layers.find(layer => layer === layerObj)
      const element = layer.elements.find(element => element === elementObj)
      this.showElementForm(layerObj, element)
    },
    /**
 * Moves an element from one layer to another in the dashboard.
 *
 * This method finds the current layer and the element to be moved in the 'dashboardState.dashboard.layers' array.
 * It then finds the target layer, which is either the layer above or below the current layer, depending on the 'moveUp' parameter.
 * The method then adds the element to the target layer's elements array, and removes it from the current layer's elements array.
 *
 * @param {string} layerId - The ID of the layer where the element is currently located.
 * @param {string} elementId - The ID of the element to be moved.
 * @param {boolean} moveUp - A boolean indicating whether the element should be moved to the layer above (true) or below (false) the current layer.
 */
    moveElementToLayer(layerObj, elementObj, moveUp) {
      const currentLayer = this.dashboardState.dashboard.layers.find(layer => layer === layerObj)
      const element = currentLayer.elements.find(element => element === elementObj)
      const index = currentLayer.elements.findIndex(element => element === elementObj)
      const currentLayerIndex = this.dashboardState.dashboard.layers.findIndex(layer => layer === layerObj)
      const layerTo = this.dashboardState.dashboard.layers.at(moveUp ? currentLayerIndex - 1 : currentLayerIndex + 1)
      layerTo.elements.push(element)
      currentLayer.elements.splice(index, 1)
    },
    /**
 * Moves an element up or down within the same layer in the dashboard.
 *
 * This method finds the current layer and the element to be moved in the 'dashboardState.dashboard.layers' array.
 * It then removes the element from its current position and inserts it either one position above or below, depending on the 'moveUp' parameter.
 *
 * @param {Object} layerObj - The layer object that contains the element.
 * @param {Object} elementObj - The element object to move.
 * @param {boolean} moveUp - If true, the element is moved up. If false, the element is moved down.
 */
    moveElement(layerObj, elementObj, moveUp) {
      const currentLayer = this.dashboardState.dashboard.layers.find(layer => layer === layerObj)
      const index = currentLayer.elements.findIndex(element => element === elementObj)
      const [element] = currentLayer.elements.splice(index, 1)
      currentLayer.elements.splice(moveUp ? index - 1 : index + 1, 0, element)
    },
    /**
     * Checks if the given layer is the last layer in the dashboard.
     *
     * @param {Object} layerObj - The layer object to check.
     * @returns {boolean} Returns true if the layer is the last layer, false otherwise.
     */
    isLastLayer(layerObj) {
      const index = this.dashboardState.dashboard.layers.findIndex(layer => layer === layerObj)
      return index === (this.dashboardState.dashboard.layers.length - 1)
    },
    /**
  * Checks if a layer is the first layer in the dashboard.
  *
  * @param {Object} layerObj - The layer object to check.
  * @returns {boolean} Returns true if the layer is the first layer in the dashboard, and false otherwise.
  */
    isFirstLayer(layerObj) {
      const index = this.dashboardState.dashboard.layers.findIndex(layer => layer === layerObj)
      return index === 0
    },
    /**
    * Checks if the given element is the last element in the specified layer.
    *
    * @param {Object} layerObj - The layer object that contains the element.
    * @param {Object} elementObj - The element object to check.
    * @returns {boolean} Returns true if the element is the last element in the layer, false otherwise.
    */
    isLastElement(layerObj, elementObj) {
      const layer = this.dashboardState.dashboard.layers.find(layer => layer === layerObj)
      const index = layer.elements.findIndex(element => element === elementObj)
      return index === (layer.elements.length - 1)
    },
    /**
     * Checks if the given element is the first element in the specified layer.
     *
     * @param {Object} layerObj - The layer object that contains the element.
     * @param {Object} elementObj - The element object to check.
     * @returns {boolean} Returns true if the element is the first element in the layer, false otherwise.
     */
    isFirstElement(layerObj, elementObj) {

      const layer = this.dashboardState.dashboard.layers.find(layer => layer === layerObj)
      const index = layer.elements.findIndex(element => element === elementObj)
      return index === 0
    },

    /**
     * Adds a new element to a given layer or updates an existing element.
     * If `newElement.isEdit` is false, a new element is added to the layer.
     * If `newElement.isEdit` is true, the existing element is updated.
     *
     * @param {Object} layerObj - The layer object to which the element is added or in which the element is updated.
     */
    onAddElement(layerObj) {
      const layer = this.dashboardState.dashboard.layers.find(layer => layer === layerObj)
      if (!this.newElement.isEdit) {
        layer.elements.push({
          //      id: this.setElementUniqId(layer),
          image: this.newElement.image,
          speed: this.newElement.speed,
          xPosition: this.newElement.xPosition,
          yPosition: this.newElement.yPosition,
          size: this.newElement.size,
          path: this.newElement.path
        })
      } else {
        const element = layer.elements.find(element => element === this.objectForFill)
        element.image = this.newElement.image
        element.speed = this.newElement.speed
        element.xPosition = this.newElement.xPosition
        element.yPosition = this.newElement.yPosition
        element.size = this.newElement.size
        element.path = this.newElement.path
      }
    },
    setDataUniqId() {
      const dataIds = this.dashboardState.dashboard.data.map((data) => data.id)
      let newId = 1
      while (dataIds.includes(newId)) {
        newId++
      }
      return newId
    },
    setLayerUniqId() {
      const layerIds = this.dashboardState.dashboard.layers.map((layer) => layer.id)
      let newId = 1
      while (layerIds.includes(newId)) {
        newId++
      }
      return newId
    },
    setElementUniqId(layer) {
      const elementIds = layer.elements.map((element) => element.id)
      let newId = 1
      while (elementIds.includes(newId)) {
        newId++
      }
      return newId
    },
    /**
 * Fetches the current state of the dashboard and stores a deep copy of it.
 *
 * This method creates a deep copy of 'this.dashboardState' by first converting it to a JSON string and then parsing it back to an object.
 * The deep copy is stored in 'this.originalDashboardState', allowing the original state to be restored later if needed.
 */
    fetchDashboardData() {
      this.originalDashboardState = JSON.parse(JSON.stringify(this.dashboardState))
    },
    /**
 * Prevents the deletion of certain characters in an input field.
 *
 * This method is triggered on keydown events in the input field. It first checks if the key pressed is a navigation key (arrow keys),
 * in which case it allows the event to proceed.
 * If the key pressed is either Backspace or Delete, it determines which character(s) are going to be deleted.
 * If the Backspace key is pressed, it gets the character before the cursor.
 * If the Delete key is pressed, it gets the character after the cursor.
 * If there's a selection, it gets the selected text.
 * If the character(s) to be deleted include '[' or ']', it prevents the event, effectively preventing the deletion of these characters.
 *
 * @param {Event} event - The keydown event.
 */
    preventDeletion(event) {
      const inputField = event.target
      const selectionStart = inputField.selectionStart
      const selectionEnd = inputField.selectionEnd
      const value = inputField.value

      // Allow navigation with arrow keys
      if (["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"].includes(event.key)) {
        return
      }

      // Determine which character(s) are going to be deleted
      let charToDelete = ''
      if (event.key === "Backspace" && selectionStart === selectionEnd) {
        // Backspace deletes the character before the cursor
        charToDelete = value.substring(selectionStart - 1, selectionStart)
      } else if (event.key === "Delete" && selectionStart === selectionEnd) {
        // Delete removes the character after the cursor
        charToDelete = value.substring(selectionStart, selectionStart + 1)
      } else if (selectionStart !== selectionEnd) {
        // If there's a selection, get the selected text
        charToDelete = value.substring(selectionStart, selectionEnd)
      }

      // Prevent deletion if the character is [ or ]
      if (charToDelete.includes('[') || charToDelete.includes(']')) {
        event.preventDefault()
      }
    },
    /**
 * Handles the change of tab.
 *
 * @param {string} tab - The tab that has been selected.
 */
    handleTabChange(tab) {
      this.tab = tab
    },
  },
  mounted() {
    this.fetchDashboardData()
  },
  data() {
    return {
      originalDashboardState: null,
      pureColor: 'undefined',
      min: 1,
      max: 100,
      value: undefined,
      base64srcElement: undefined,
      newElement: undefined,
      newLayer: undefined,
      newBubble: undefined,
      isSaving: false,
      showColorPicker: false,
      file: null,
      level: 0,
      imagePreview: null,
      openDialogs: {},
      tab: 'tabAll',
      deleteLayerFormVisible: false,
      showLayerFormVisible: false,
      onlyImg: false,
      showDataTypesFormVisible: false,
      showElementFormVisible: false,
      layerIdToDelete: undefined,
      layerObjectToDelete: undefined,
      layerObj: undefined,
      objectForFill: undefined,
      elementModaldialogKey: 0,
      bubbleObj: undefined,
      isBubbleIcon: false,
    }
  }
}
</script>
<style lang="scss" scoped>
.root {
  color: black;
  padding: 20px;
  text-align: left;
  height: 93%;
  min-width: 600px;
  overflow-x: hidden;

  h1 {
    margin-top: 0px;
  }
}

.editor-block {
  margin-bottom: 16px;
  padding: 20px;

  h2:first-child {
    margin-top: 0px;
  }
}

.content-block {
  max-height: 76%;
  overflow-y: auto;
  border: 1px solid black;
  border-radius: 5px !important;
  padding: 20px 20px;
  margin-bottom: 16px;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12);

}

.card {
  margin-top: 16px;
  padding: 8px 20px;
}

.editor-form {
  display: inline-grid;
  grid-template-columns: auto auto;
  column-gap: 4px;
  row-gap: 4px;
}

.image {
  display: block;
}

.editor-form+.image,
.image+.editor-form {
  margin-top: 20px;
}

.btn-green {
  background-color: green;
  color: white;
  border: none;
  padding: 8px 16px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 12px;
  margin: 4px 2px;
  cursor: pointer;
}

.btn-gray {
  background-color: #808080;
  color: white;
  border: none;
  padding: 8px 16px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 12px;
  margin: 4px 2px;
  cursor: pointer;
}

.btn-blue-margin {
  margin: 4px 2px;
  cursor: pointer;
}

.loader {
  width: 10px;
  height: 10px;
  border: 5px solid #FFF;
  border-bottom-color: #0077B6;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
  margin-left: 4px;
}

.footer {
  padding: 0 0 20px 20px;
  height: 40px;
  text-align: left;
}

h4,
h3,
h2 {
  margin: 16px;
}

.button-row {
  display: flex;
  align-items: center;
  gap: 10px;
  /* adjust this value to add space between the buttons */
  padding: 0px;
}
</style>
